import React from 'react'
import OFFICEIcon from '../../../images/icon/file_type_icon_04.png';
import {useTranslation} from "react-i18next";
import classNames from "classnames";

const OFFICE = ({onlyIcon = false, embedded = false}) => {
    const {t} = useTranslation();
    return(
        <span className={classNames('content_icon',{'embedded': embedded === true})}>
            <img src={OFFICEIcon}/>
            {
                !onlyIcon && t('TEXT_TITLE_OFFICE_P')
            }

        </span>
    )
}
export default OFFICE;